var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback } from 'react';
import { WidgetType } from '@common/api';
import { useTagContext } from '@data/tag/tagContext';
import { parseWidgetConfig } from '@data/widgets/widgetConfig';
import { useUpdateWidget, useWidgets } from '@data/widgets/widgetActions';
import { DraggableType, DroppableType, SingleValueZone } from './types';
export function useSingleValueWidgetToEmptyHandler() {
    var _a;
    var widgets = (_a = useWidgets().data) !== null && _a !== void 0 ? _a : [];
    var tagData = useTagContext().tagData;
    var updateWidgetMutation = useUpdateWidget();
    return useCallback(function (sourceInfo, targetInfo, draggableInfo) {
        // source, target and draggable checks
        if (sourceInfo.type !== DroppableType.SingleValueWidget ||
            targetInfo.type !== DroppableType.Empty ||
            draggableInfo.type !== DraggableType.Tag) {
            return { status: 'error' };
        }
        // find tag and widget
        var tag = tagData.tagById[draggableInfo.tagId];
        if (tag === undefined) {
            return { status: 'error', message: 'Tag not found' };
        }
        var widget = widgets.find(function (w) { return w.id === sourceInfo.widgetId; });
        if (widget === undefined) {
            return { status: 'error', message: 'Widget not found' };
        }
        // update widget by area
        var widgetZone = sourceInfo.zone;
        var field = null;
        if (widgetZone === SingleValueZone.Variable) {
            field = 'accountTags';
        }
        else if (widgetZone === SingleValueZone.Filter) {
            field = 'filterTags';
        }
        else if (widgetZone === SingleValueZone.Comparison) {
            field = 'comparisonTags';
        }
        if (field !== null) {
            var widgetConfig = parseWidgetConfig(widget.config, WidgetType.SINGLEVALUE);
            if (widgetConfig[field].includes(tag.id)) {
                widgetConfig[field] = widgetConfig[field].filter(function (tagId) { return tagId !== tag.id; });
                updateWidgetMutation.mutate(__assign(__assign({}, widget), { config: JSON.stringify(widgetConfig) }));
            }
            return { status: 'success' };
        }
        return { status: 'error', message: 'Unknown zone in single value' };
    }, [widgets, tagData, updateWidgetMutation]);
}
export function useSingleValueWidgetToSingleValueWidgetHandler() {
    return useCallback(function (sourceInfo, targetInfo, draggableInfo, combineDraggableInfo, targetIndex) {
        // WIP
        return { status: 'error', message: 'Not implemented yet' };
    }, []);
}
